import React, {Component} from 'react';

const google = window.google;
let map, marker, infowindow;
let theme = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

export default class SingleProjectMap extends Component {
	componentDidMount() {
		let lat = parseFloat(this.props.selectedProject.latitude);
		let lng = parseFloat(this.props.selectedProject.longitude);

		map = new google.maps.Map(this.refs.map, {
			center: {lat, lng},
			zoom: 10,
			styles: theme,
			disableDefaultUI: false,
			zoomControl: true
		});

		this.componentDidUpdate();
	}

	componentDidUpdate() {
		let lat = parseFloat(this.props.selectedProject.latitude);
		let lng = parseFloat(this.props.selectedProject.longitude);

		let icon= {
			url: `${process.env.PUBLIC_URL + '/img/red-marker.png'}`, // url
			scaledSize: new google.maps.Size(32, 32), // scaled size
			origin: new google.maps.Point(0,0), // origin
			anchor: new google.maps.Point(12, 32) // anchor
		};

		marker = new google.maps.Marker({
			position: {lat, lng},
			icon: icon,
			map: map,
			animation: google.maps.Animation.DROP,
		});

		marker.setMap(map);
	}

	render() {
		return (
			<div>
				<div style={{width: this.props.width, height: 200, border: '1px solid black'}} ref="map"></div>
			</div>
		);
	}
}